module.exports = __webpack_public_path__ + "static/assets/2613dd347943b2ed7c6edb22e0cf7e0a.mp3";